export const statusClasses = {
  success: 'bg-success border border-green-600 text-white',
  warning: 'bg-warning-lighter border border-warning',
  danger: 'bg-danger border border-red-600 text-white',
  inactive: 'bg-information-lighter border border-information-darker'
}

export const securePaymentStatus = {
  LIVE: 'L',
  COMPLETED: 'C',
  CANCELLED: 'N',
  WITHDRAWN: 'W',
  DISPUTED: 'D'
}

export const securePaymentStates = {
  AWAITING_ACCEPTANCE: 0,
  AWAITING_PAYMENT: 1,
  AWAITING_CONFIRM_MOVEMENT: 2,
  AWAITING_RELEASE_FUNDS: 4,
  RELEASING_FUNDS: 5,
  PREPARING_WITHDRAWAL: 6,
  DECLINE_BEFORE_ACCEPT: 7,
  CANCELLED_BEFORE_FUNDING: 8,
  PAYMENT_WITHDRAWING: 8,
  PAYMENT_COMPLETE: 10,
  CANCELLED_AFTER_FUNDING: 12,
  REFUND_IN_PROGRESS: 13,
  REFUND_COMPLETE: 14
}

export const securePaymentDisputeStates = {
  RESOLVED: 0,
  ACTIVE: 1,
  WITHDRAWN: 2,
  PROCESSING: 3
}

export default {
  0: {
    description: 'Awaiting Acceptance',
    buyer: { statusLabel: 'awaiting acceptance', title: 'Awaiting Acceptance' },
    seller: { statusLabel: 'awaiting acceptance', title: 'Awaiting Acceptance' },
    actionRequired: 'both',
    tagClass: statusClasses.warning,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP0AwaitingAcceptance')
  },
  1: {
    description: 'Awaiting Payment',
    buyer: { statusLabel: 'awaiting payment', title: 'Awaiting Payment' },
    seller: { statusLabel: 'awaiting buyer', title: 'Awaiting Payment' },
    actionRequired: 'buyer',
    tagClass: statusClasses.warning,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP1AwaitingPayment')
  },
  2: {
    description: 'Awaiting Movement',
    buyer: { statusLabel: 'payment received', title: 'Payment Received!' },
    seller: { statusLabel: 'confirm movement', title: 'Confirm Movement' },
    actionRequired: 'seller',
    tagClass: statusClasses.warning,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP2AwaitingMovement')
  },
  // This is a stage shieldpay has but we skip past
  // 3: {
  //   description: 'Approved',
  //   buyer: { statusLabel: 'approving payment', title: 'Request Sent' },
  //   seller: { statusLabel: 'awaiting buyer', title: 'Request Sent' },
  //   tagClass: statusClasses.warning,
  //   component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSPAwaitingAcceptance')
  // },
  4: {
    description: 'Awaiting Funds Release',
    buyer: { statusLabel: 'release funds', title: 'Release Funds' },
    seller: { statusLabel: 'awaiting buyer', title: 'Confirm Delivery & Release Funds' },
    actionRequired: 'buyer',
    tagClass: statusClasses.warning,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP4AwaitingFundsRelease')
  },
  5: {
    description: 'Releasing Funds',
    buyer: { statusLabel: 'complete', title: 'Transaction Complete' },
    seller: { statusLabel: 'releasing funds', title: 'Releasing Funds' },
    tagClass: statusClasses.success,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP5ReleasingFunds')
  },
  6: {
    description: 'Funds Ready To Withdraw',
    buyer: { statusLabel: 'releasing', title: 'Payment Complete' },
    seller: { statusLabel: 'releasing', title: 'Preparing Withdrawal' },
    tagClass: statusClasses.success,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP6Withdrawing')
  },
  7: {
    description: 'Other Party Declined Before Accept',
    buyer: { statusLabel: 'cancelled', title: 'Payment Cancelled' },
    seller: { statusLabel: 'cancelled', title: 'Payment Cancelled' },
    tagClass: statusClasses.inactive,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP7Cancelled')
  },
  8: {
    description: 'Cancelled Before Funding',
    buyer: { statusLabel: 'cancelled', title: 'Payment Cancelled' },
    seller: { statusLabel: 'cancelled', title: 'Payment Cancelled' },
    tagClass: statusClasses.inactive,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP7Cancelled')
  },
  9: {
    description: 'Payment Generated (Withdrawing)',
    buyer: { statusLabel: 'releasing', title: 'Payment Complete' },
    seller: { statusLabel: 'releasing', title: 'Preparing Withdrawal' },
    tagClass: statusClasses.success,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP6Withdrawing')
  },
  10: {
    description: 'Payment Complete',
    buyer: { statusLabel: 'complete', title: 'Payment Complete' },
    seller: { statusLabel: 'complete', title: 'Payment Complete' },
    tagClass: statusClasses.success,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP10Complete')
  },
  11: {
    description: 'Funding Pending',
    buyer: { statusLabel: 'awaiting funds', title: 'Funding Pending' },
    seller: { statusLabel: 'awaiting funds', title: 'Funding Pending' },
    tagClass: statusClasses.warning,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP11FundingPending')
  },
  12: {
    description: 'Cancelled After Funding',
    buyer: { statusLabel: 'cancelled', title: 'Payment Cancelled' },
    seller: { statusLabel: 'cancelled', title: 'Payment Cancelled' },
    tagClass: statusClasses.inactive,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP12CancelledAfterFunding')
  },
  13: {
    description: 'Refund In Progress',
    buyer: { statusLabel: 'refunding', title: 'Refunding' },
    seller: { statusLabel: 'refunding', title: 'Refunding' },
    tagClass: statusClasses.warning,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP13RefundInProgress')
  },
  14: {
    description: 'Refund Complete',
    buyer: { statusLabel: 'refunded', title: 'Refunded' },
    seller: { statusLabel: 'refunded', title: 'Refunded' },
    tagClass: statusClasses.success,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP14Refunded')
  },
  15: {
    description: 'Cancelled Due to Fraud',
    buyer: { statusLabel: 'fraud detected', title: 'Fraud Detected' },
    seller: { statusLabel: 'fraud detected', title: 'Fraud Detected' },
    tagClass: statusClasses.danger,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP15FraudDetected')
  },
  16: {
    description: 'Withdraw Suspended',
    buyer: { statusLabel: 'suspended', title: 'Withdraw Suspended' },
    seller: { statusLabel: 'suspended', title: 'Withdraw Suspended' },
    tagClass: statusClasses.danger,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP16WithdrawSuspended')
  },
  17: {
    description: 'Shieldpay Internal Cancel',
    buyer: { statusLabel: 'cancelled', title: 'Payment Cancelled' },
    seller: { statusLabel: 'cancelled', title: 'Payment Cancelled' },
    tagClass: statusClasses.inactive,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP17ShieldpayCancel')
  },
  18: {
    description: 'Replaced Transaction',
    buyer: { statusLabel: 'disputed', title: 'Processing Dispute' },
    seller: { statusLabel: 'disputed', title: 'Processing Dispute' },
    tagClass: statusClasses.warning,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP18ReplacedTransaction')
  }
}

export const disputedStatusConfig = {
  1: {
    description: 'Disputed',
    buyer: { statusLabel: 'disputed', title: 'Disputed' },
    seller: { statusLabel: 'disputed', title: 'Dispute Raised' },
    tagClass: statusClasses.warning,
    component: () => import('@/components/utils/payment/secure-payments/view-states/disputed/UtilSPDispute1Active')
  },
  2: {
    description: 'Locked',
    buyer: { statusLabel: 'disputed', title: 'Awaiting Dispute Review' },
    seller: { statusLabel: 'disputed', title: 'Awaiting Dispute Review' },
    tagClass: statusClasses.warning,
    component: () => import('@/components/utils/payment/secure-payments/view-states/disputed/UtilSPDispute2Locked')
  },
  3: {
    description: 'Withdrawn',
    buyer: { statusLabel: 'release funds', title: 'Release Funds' },
    seller: { statusLabel: 'awaiting buyer', title: 'Awaiting Funds Release' },
    actionRequired: 'buyer',
    tagClass: statusClasses.warning,
    component: () => import('@/components/utils/payment/secure-payments/view-states/UtilSP4AwaitingFundsRelease')
  },
  4: {
    description: 'Processing Refund',
    buyer: { statusLabel: 'refunding', title: 'Refunding' },
    seller: { statusLabel: 'refunding', title: 'Refunding' },
    tagClass: statusClasses.success,
    component: () =>
      import('@/components/utils/payment/secure-payments/view-states/disputed/UtilSPDispute4Refunding')
  }
}
